var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Menu } from '../../components/Menu';
export class SingleProduct extends Component {
    constructor() {
        super('SingleProduct', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Key events
            if ($('.carousel').length > 0) {
                $(window).on('keyup', (event) => {
                    if (event.key === 'ArrowLeft')
                        $('.carousel-control-prev').trigger('click');
                    if (event.key === 'ArrowRight')
                        $('.carousel-control-next').trigger('click');
                });
            }
            // Gallery
            $('#btn-fullscreen').on('click', (event) => {
                event.preventDefault();
                $('#product-gallery').removeClass('d-none');
            });
            $('#product-gallery .btn-close').on('click', (event) => {
                event.preventDefault();
                $('#product-gallery').addClass('d-none');
            });
            // Add to cart
            $('.btn-add-to-cart').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                button.addClass('disabled');
                const response = yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        action: 'hw_add_to_cart',
                        product_id: $(event.currentTarget).data('productId'),
                        quantity: 1,
                    },
                    dataType: 'json'
                });
                Menu.updateCartCounter(response.product_count);
                $('#toast-added-to-cart').addClass('show');
                setTimeout(() => {
                    $('#toast-added-to-cart').removeClass('show');
                }, 3000);
                button.removeClass('disabled');
            }));
            this.success();
        });
    }
}
